module.exports = {
      id: "boom1000 index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#boom1000 index-usage",
      toString: function () {
        return this.url;
      }
    }